import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import * as AreasActions from './areas.actions';
import { AreasService } from '../services/areas.service';
import { map } from 'rxjs';

@Injectable()
export class AreasEffects {
    init$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(AreasActions.init),
            fetch({
                run: () => {
                    return this.areasService.getAreas().pipe(map(areas => AreasActions.loadAreasSuccess({ areas })));
                },
                onError: (action, error) => {
                    console.error('Error', error);
                    return AreasActions.loadAreasFailure({ error });
                }
            })
        );
    });

    constructor(private readonly actions$: Actions, private areasService: AreasService) {}
}
